import { render, staticRenderFns } from "./audit-logs-page.vue?vue&type=template&id=0df7ea85&"
import script from "./audit-logs-page.vue?vue&type=script&lang=ts&"
export * from "./audit-logs-page.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports